import { levelsToPageCategories } from 'src/adapters/pageURLToStore/taxonomyPath';
import { deriveTaxonomyLevelsFromFacets } from 'src/adapters/storeToPageURL/deriveTaxonomyLevelsFromFacets';
import type {
  ProductsQueryState,
  SyncProductsQueryFromURLPayload,
} from '../types/ProductsQueryState';
import { markActiveFacetOptions } from './markActiveFacetOptions';
import { markActiveSortOption } from './markActiveSortOption';

export const getProductsQueryStateFromSyncPayload = (
  productsQuery: ProductsQueryState,
  active: SyncProductsQueryFromURLPayload,
): ProductsQueryState => {
  const facets = markActiveFacetOptions(productsQuery.facets, active.activeFacetValuesByKey);

  // For taxonomy pages pageCategories follows the active facet selection; other pages keep
  // whatever was set at SSR-init time (their pathname doesn't change after navigation).
  const pageCategories =
    productsQuery.taxonomyAttributeAliases.length > 0
      ? levelsToPageCategories(
          deriveTaxonomyLevelsFromFacets(facets, productsQuery.taxonomyAttributeAliases),
        )
      : productsQuery.pageCategories;

  return {
    ...productsQuery,
    facets,
    sortOptions: markActiveSortOption(productsQuery.sortOptions, active.activeSort),
    page: active.page,
    searchTerm: active.searchTerm,
    pageCategories,
  };
};
